// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__XiyPB","row":"Landing_row__K-Bah"};